import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { checkAndFormatPhoneNumber } from "../../lib/utils";
import BookingFormCard from "./BookingFormCard";
import BookingServiceItem from "./BookingServiceItem";
import BookingFormHeader from "./BookingFormHeader";
import BookingFormCardPrices from "./BookingFormCardPrices";
import ArrUpIcon from "../ui/ArrUpIcon";
import BookingFormSteps from "./BookingFormSteps";

function BookingFormServices({
  booking,
  hoteldata,
  datein,
  dateout,
  prevStep,
  nextStep,
  onClose,
}) {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    guestname: [],
    guestsurname: [],
  });
  const [phoneNumber, setPhoneNumber] = useState(
    checkAndFormatPhoneNumber("")[0],
  );
  const [scrolled, setScrolled] = useState(0);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   setFormData({
  //     name: app?.userData?.name || "",
  //     surname: app?.userData?.lastname || "",
  //     email: app?.userData?.email || "",
  //     guestname: [app?.userData?.name || ""],
  //     guestsurname: [app?.userData?.lastname || ""],
  //   });
  //   setPhoneNumber(checkAndFormatPhoneNumber(app?.userData?.phone.slice(1))[0]);
  //   setLoading(false);
  // }, [app.userData.email]);

  // обработчик скролла, чтобы свернуть подробности
  // обновляет флаг, на который реагирует компонент со списком "все условия"
  const handleScroll = (event) => {
    const { scrollTop } = event.target;
    setScrolled((prev) => prev + 1);
  };

  if (loading) {
    return <p>Обновляю форму.. 2</p>;
  }

  return (
    <div>
      <div className="bookingWrap formTwo" onScroll={handleScroll}>
        <BookingFormHeader
          title="Услуги"
          datein={datein}
          dateout={dateout}
          onClose={onClose}
        />
        {/* <BookingFormConditions hoteldata={hoteldata} booking={booking} /> */}
        <div className="bookingForm">
          <div className="bookingCard bookingCard__services">
            <div className="bookingCard">
              <h3 className="bookingCard__title mob_show">Услуги</h3>
              {hoteldata?.services?.service?.length > 0 &&
                hoteldata.services.service.map((service) => {
                  // ограничение максимального кол-ва услуг для услуг с датой
                  const s = booking.selectedServices?.find(
                    (f) => f.id === service._id,
                  );
                  let count = 0;
                  if (s) {
                    count = booking.selectedServices?.filter(
                      (f) => f.id === service._id,
                    ).length;
                  }

                  return (
                    <BookingServiceItem
                      key={`serv${service._id}`}
                      {...service}
                      service={service}
                      days={hoteldata.services.days?.[service._id] || []}
                      addServiceHandler={booking.addService}
                      selected={{ ...s, count }}
                      booking={booking}
                      datein={datein}
                      dateout={dateout}
                    />
                  );
                })}
              {hoteldata?.services?.product?.length > 0 &&
                hoteldata.services.product.map((product) => (
                  <BookingServiceItem
                    key={`prod${product._id}`}
                    {...product}
                    service={product}
                    selected={booking.selectedServices?.find(
                      (f) => f.id === product._id,
                    )}
                    addServiceHandler={booking.addService}
                    booking={booking}
                    datein={datein}
                    dateout={dateout}
                  />
                ))}
            </div>
          </div>
          <BookingFormCardPrices hoteldata={hoteldata} booking={booking} />
          <BookingFormCard
            booking={booking}
            hoteldata={hoteldata}
            step="services"
            scrolled={scrolled}
            prevStep={prevStep}
            nextStep={nextStep}
            datein={datein}
            dateout={dateout}
            onClose={onClose}
          />
        </div>
        <div className="bookingCard__navBtns dfsp dfa mob_hide">
          <span className="changeTariff" onClick={prevStep}>
            <ArrUpIcon fill="#36549C" />
            назад
          </span>
          <button className="bookingCard__nextBtn" onClick={nextStep}>
            Далее
          </button>
        </div>
        <BookingFormSteps step="services" count={hoteldata.steps_count} />
      </div>
    </div>
  );
}

export default observer(BookingFormServices);
